export const decisioningStudioAgentsAppGroupIdDsaIdPerformanceReportSettings =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/performance_report/settings";
